var map = {
	"./Computing": [
		25012,
		9
	],
	"./Computing.js": [
		25012,
		9
	],
	"./Paper": [
		53620,
		9
	],
	"./Paper.js": [
		53620,
		9
	],
	"./Water": [
		81854,
		9
	],
	"./Water.js": [
		81854,
		9
	],
	"./additional": [
		63571,
		9
	],
	"./additional.js": [
		63571,
		9
	],
	"./bulk_materials": [
		56251,
		9
	],
	"./bulk_materials.js": [
		56251,
		9
	],
	"./cars": [
		16978,
		9
	],
	"./cars.js": [
		16978,
		9
	],
	"./commuting": [
		41467,
		9
	],
	"./commuting.js": [
		41467,
		9
	],
	"./electricity": [
		2679,
		9
	],
	"./electricity.js": [
		2679,
		9
	],
	"./flight": [
		6370,
		9
	],
	"./flight.js": [
		6370,
		9
	],
	"./freighting": [
		25139,
		9
	],
	"./freighting.js": [
		25139,
		9
	],
	"./fuel": [
		31351,
		9
	],
	"./fuel.js": [
		31351,
		9
	],
	"./heatandsteam": [
		29769,
		9
	],
	"./heatandsteam.js": [
		29769,
		9
	],
	"./home_workers": [
		82589,
		9
	],
	"./home_workers.js": [
		82589,
		9
	],
	"./hotel": [
		82509,
		9
	],
	"./hotel.js": [
		82509,
		9
	],
	"./ingredients": [
		44013,
		9
	],
	"./ingredients.js": [
		44013,
		9
	],
	"./naturalgas": [
		44731,
		9
	],
	"./naturalgas.js": [
		44731,
		9
	],
	"./other_travels": [
		85197,
		9
	],
	"./other_travels.js": [
		85197,
		9
	],
	"./product": [
		33189,
		9
	],
	"./product.js": [
		33189,
		9
	],
	"./refrigerator": [
		78451,
		9
	],
	"./refrigerator.js": [
		78451,
		9
	],
	"./spending": [
		51014,
		9
	],
	"./spending.js": [
		51014,
		9
	],
	"./temp": [
		48732,
		3,
		732
	],
	"./temp.json": [
		48732,
		3,
		732
	],
	"./waste": [
		87965,
		9
	],
	"./waste.js": [
		87965,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 24153;
module.exports = webpackAsyncContext;